<template>
  <!-- 招投标列表组件 -->
  <div class="ztbList">
    <div
      class="ztbTop"
      v-bind:style="{padding: ztbListPadding}"
    >
      <div class="ztbTitle" @click="goTender()" style="display: flex;flex-wrap: nowrap;">
        <div>
        <!-- 中标：em去掉类名ztbStatus；招标加上类名ztbStatus -->
        <em
          :class="ztbStatus=='招'?'ztbStatus':''"
          v-show="ztbStatusShow"
        >{{ztbStatus}}</em>
        <span v-if="ztbIndex" style="font-weight: bold;">{{ztbIndex}}.</span>
        <span v-html="ztbTitle" class="ztbSpanTitle"></span>
        </div>
         <div><em v-if="ztbBidding===1" style="margin-left: 10px;">中</em></div>
      </div>

      <div class="con-right">
        <div
          class="attentionBtn"
          v-show="attentionBtnShow"
          @click="cancelAttentionProject()"
        >取消关注</div>
        <div
          class="ztbMoney"
          v-show="ztbMoneyShow"
          @click="goTender()"
        >{{ztbMoney}}</div>
        <div
          class="ztbType"
          v-show="ztbTypeShow"
          @click="goTender()"
        >{{ztbType}}</div>
        <div
          class="ztbTSource"
          v-show="ztbTSourceShow"
          @click="goTender()"
        >{{ztbTSource}}</div>
        <div
          class="ztbTime"
          v-show="ztbTimeShow"
          @click="goTender()"
        >{{ztbTime}}</div>
      </div>
    </div>
    <div
      class="ztbContent"
      v-html="ztbContent"
      @click="goTender()"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ztbList",
  data() {
    return {};
  },
  // 父组件子组件传参
  props: [
    "ztbBidding",
    "ztbIndex",
    "ztbListPadding",
    "moneyStatus",
    "ztbStatus",
    "ztbStatusShow",
    "ztbTitle",
    "ztbMoney",
    "ztbMoneyShow",
    "ztbType",
    "ztbTypeShow",
    "ztbTSource",
    "ztbTSourceShow",
    "ztbTime",
    "ztbTimeShow",
    "ztbContent",
    "attentionBtnShow"
  ],
  methods:{
    cancelAttentionProject:function () {
      this.$emit("cancelAttentionProject");
    },
    goTender:function () {
      this.$emit("goTender");
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.ztbList {
  min-height: 42px;
  line-height: 42px;
  font-size: 14px;
  color: #535353;
  border-bottom: 1px solid #f4f4f4;
  cursor: pointer;
}
.ztbList:hover{
  background-color: #efefef;
  padding-left: 5px;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}
.ztbTop {
  /* padding-right: 485px; */
  padding-right: 300px;
  position: relative;
}
.ztbList em {
  display: inline-block;
  width: 20px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  background: linear-gradient(
    135deg,
    rgba(255, 132, 132, 1) 0%,
    rgba(224, 83, 83, 1) 100%
  );
  border-radius: 1px;
  margin-right: 5px;
  vertical-align: top;
  margin-top: 11px;
}
.ztbList em.ztbStatus {
  background: linear-gradient(
    132deg,
    rgba(69, 240, 196, 1) 0%,
    rgba(21, 181, 119, 1) 100%
  );
}
.ztbList .ztbTitle {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ztbList .con-right {
  position: absolute;
  top: 0;
  right: 0;
}
.ztbList .con-right > div {
  display: inline-block;
  margin-left: 10px;
}
.ztbList .ztbTime {
  color: #949494;
  padding-left: 23px;
  padding-right: 10px;
  background: url(../ztbList/img/timeIco.png) left center no-repeat;
}
.ztbList .ztbTSource {
  color: #535353;
  padding-left: 19px;
  background: url(../ztbList/img/mapIco.png) left center no-repeat;
}
.ztbList .ztbType {
  height: 24px;
  line-height: 24px;
  padding: 0 10px;
  text-align: center;
  background: linear-gradient(
    162deg,
    rgba(51, 107, 142, 1) 0%,
    rgba(25, 159, 175, 1) 100%
  );
  border-radius: 1px;
  color: #fff;
  margin-top: 10px;
}
.ztbList .ztbMoney {
  height: 24px;
  line-height: 24px;
  min-width: 63px;
  text-align: center;
  background: linear-gradient(
    324deg,
    rgba(235, 212, 95, 1) 0%,
    rgba(213, 166, 25, 1) 100%
  );
  border-radius: 1px;
  color: #fff;
  margin-top: 10px;
  padding: 0 5px;
}
.ztbList .ztbContent {
  text-align: left;
  line-height: 24px;
  margin-top: -10px;
  font-size: 12px;
  color: #959595;
}
.ztbList .attentionBtn {
  color: #ff5a5a;
  border: 1px solid #ff5a5a;
  font-size: 14px;
  width: 70px;
  text-align: center;
  height: 22px;
  line-height: 22px;
  display: inline-block;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ztbList/ztbList.vue